export const styles = {
  container: {
    height: 25 * 8,
  },
  iconsGraphContainer: {
    height: 26.5 * 8,
    ml: 3,
    display: "flex",
  },
  iconsContainer: {
    mr: -1,
    display: "flex",
    flexDirection: "column",
    mt: 1,
    height: 24.5 * 8,
    justifyContent: "space-between",
  },
  graphContainer: {
    mt: 2,
    width: "98%",
  },
}
